import { updateOrganisationRole } from '@infuse/api/iam/organisation';
import { useGenericUpdateRole } from '@infuse/iam/role/mutations';

export const useUpdateOrganisationRole = () => {
  return useGenericUpdateRole({
    apiFn: updateOrganisationRole
  });
};
